import { Timer } from "lucide-react";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import type { Task } from "@/lib/db";
import { FocusRunningError, startFocus } from "@/lib/focus";
import { defaultFocusMinutes } from "@/lib/focus-timer";

/** Starts a focus session on a task and opens focus mode (FC-1). */
export function FocusButton({ task, className }: { task: Task; className?: string }) {
	const navigate = useNavigate();

	async function start() {
		try {
			await startFocus({ planned_min: defaultFocusMinutes(task), task_id: task.id });
			navigate("/focus");
		} catch (err) {
			if (err instanceof FocusRunningError) {
				toast.info("A focus session is already running.");
				navigate("/focus");
			} else {
				toast.error("Could not save on this device. Try again.");
			}
		}
	}

	return (
		<Button
			variant="ghost"
			size="icon"
			className={className ?? "size-11 md:size-9"}
			aria-label={`Focus: ${task.title}`}
			title={`Focus for ${defaultFocusMinutes(task)} min`}
			onClick={start}
		>
			<Timer />
		</Button>
	);
}
